import type { MemberMessageTemplateListFilter } from '../../../lib/core/definitions'

const getMemberMessageTemplateListFilter = (): MemberMessageTemplateListFilter => ({
})

export default getMemberMessageTemplateListFilter
